import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { CheckCircle2, ChevronLeft } from "lucide-react";
import { API } from "@/constants";
import Disclaimer from "@/components/shared/Disclaimer";
import Footer from "@/components/shared/Footer";

const ParalegalNetworkPage = () => {
  const [tiers, setTiers] = useState([]);
  const [loading, setLoading] = useState(true);
  
  useEffect(() => {
    const load = async () => {
      try {
        const res = await axios.get(`${API}/services/paralegals/tiers`);
        setTiers(res.data.tiers || []);
      } catch (e) {
        console.error(e);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);
  
  return (
    <main className="min-h-screen bg-slate-50" data-testid="paralegal-network-page">
      <Disclaimer />
      <div className="container-shell py-8 max-w-6xl">
        <div className="mb-6">
          <Link to="/tools/services-hub" className="text-sm text-muted-foreground hover:text-foreground flex items-center gap-1 mb-4">
            <ChevronLeft className="h-4 w-4" /> Back to Services Hub
          </Link>
          <h1 className="text-3xl font-bold mb-2" style={{ fontFamily: "'Fraunces', serif" }}>Paralegal Network</h1>
          <p className="text-muted-foreground">Offshore economy to onshore premium staffing solutions</p>
        </div>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4">
          {tiers.map((tier, i) => (
            <Card key={i} className={tier.id.includes('premium') ? "border-amber-300 ring-1 ring-amber-200" : ""}>
              <CardContent className="p-5">
                <h3 className="font-semibold text-lg mb-1">{tier.name}</h3>
                <p className="text-sm text-muted-foreground mb-3">{tier.description}</p>
                <div className="mb-4">
                  <p className="text-3xl font-bold">${tier.hourly_rate}<span className="text-sm font-normal text-muted-foreground">/hr</span></p>
                  <p className="text-sm text-muted-foreground">${tier.monthly_rate}/mo (40 hrs)</p>
                </div>
                <div className="mb-4">
                  <p className="text-xs font-semibold text-muted-foreground mb-2">BEST FOR:</p>
                  <ul className="text-sm space-y-1">
                    {tier.best_for?.slice(0, 3).map((item, j) => (
                      <li key={j} className="flex items-center gap-2">
                        <CheckCircle2 className="h-3 w-3 text-emerald-500" />
                        {item}
                      </li>
                    ))}
                  </ul>
                </div>
                <Button className="w-full" variant={tier.id.includes('premium') ? "default" : "outline"}>
                  Request Paralegal
                </Button>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
      <Footer />
    </main>
  );
};


export default ParalegalNetworkPage;
